import React, { FC } from "react";
import {
  InputAdornment as MuiInputAdornment,
  InputAdornmentProps,
} from "@mui/material";

const InputAdornment: FC<InputAdornmentProps> = (props) => (
  <MuiInputAdornment {...props} />
);

export default InputAdornment;
